import React from 'react';
import { connect } from 'react-redux';
import OnImagesLoaded from 'react-on-images-loaded';

import * as applyOffersActions from '../../../redux/applyOffers';
import './export-applicants.scss';
import { formatBigNumber, formatDecimalNumber } from "../../../helpers";

interface Props {
  match: any;
  applyOffers: any;
  fetchOffer: Function;
}

class ExportApplicants extends React.Component<Props> {

  componentDidMount() {

    this.props.fetchOffer(this.props.match.params.offerId, this.props.match.params.filter);
  }

  listApplicants() {

    const applicants: JSX.Element[] = [];

    /**
     * Array format:
     * [key/name, title, array of available genders]
     */
    const availableAttributes = [
      ['height', 'HEIGHT', ['f', 'm']],

      ['bust_size', 'BUST', ['f']],
      ['shirt_size', 'SHIRT', ['m']],

      ['waist_size', 'WAIST', ['f', 'm']],

      ['hips_size', 'HIPS', ['f']],
      ['inseam_size', 'INSEAM', ['m']],

      ['dress_size', 'DRESS', ['f']],
      ['suit_size', 'SUIT', ['m']],

      // Shared
      ['shoe_size', 'SHOE', ['f', 'm']],
      ['hair_color', 'HAIR', ['f', 'm']],
      ['eye_color', 'EYES', ['f', 'm']]
    ];

    for (let applicant of this.props.applyOffers.applicants) {

      let className: any = undefined;
      let attributes: JSX.Element[] = [];

      for (let index in availableAttributes) {

        className = null;

        if (availableAttributes[index][2].includes(applicant.model.sex)) {

          let key = availableAttributes[index][0].toString();
          let value: any = applicant.model.stats[key]
            ? applicant.model.stats[key]
            : undefined;

          if (key === 'shirt_size') {
            className = 'applicant__section-lower';
            value = null;
          }

          if (value === undefined) {

            continue;
          }

          switch (key) {

            case 'age': {


            } break;

            case 'shirt_size': {
              value = applicant.model.stats['sleeve_size'] ?
                formatDecimalNumber(applicant.model.stats['sleeve_size'].inches) + ' x ' +
                formatDecimalNumber(applicant.model.stats['collar_size'].inches)
                : null;
            } break;

            case 'height': {
              value = value.feet + '\' ' + formatDecimalNumber(value.inches);
            } break;

            case 'background': {
              value = value.join(', ');
            } break;

            case 'bust_size':
            case 'inseam_size':
            case 'hips_size': {
              value = value
                ? formatDecimalNumber(value.inches)
                : null;
            } break;

            case 'shoe_size': {
              value = formatDecimalNumber(value) + ' US';
            } break;

            default: {
              value = value.toString();
            } break;
          }

          if (value !== undefined) {

            attributes.push(<dt>{availableAttributes[index][1]}</dt>);
            attributes.push(<dd className={className}>{value}</dd>);
          }
        }
      }

      applicants.push(
        <div className="applicant">
          <div className="applicant__head">
            <div className="applicant__info">
              <h2>{applicant.model.name}</h2>
              {applicant.model.instagram ?
                  <span>
                    <a href={applicant.model.instagram.profile_url}>@{applicant.model.instagram.handle}</a>
                    &nbsp;/&nbsp;{formatBigNumber(applicant.model.instagram.number_of_followers)} Followers
                  </span>
                : null }
            </div>
            <img src="/img/neoncoat-icon.png" />
          </div>
          <div className="applicant__body">
            <div className="applicant__section">
              <dl className="applicant__attributes">
                {attributes}
              </dl>
            </div>
            {applicant.model.media.slice(0, 3).map((media, index) => {
              return <div className="applicant__section">
                <img src={media.thumbnail} />
              </div>
            })}
          </div>
        </div>
      );
    }

    return applicants;
  }

  render() {

    if (this.props.applyOffers.applicants.length === 0) return null;

    return (
      <OnImagesLoaded onLoaded={() => {}}>
        <div className={"pdf-render"} id="applicants">{this.listApplicants()}</div>
      </OnImagesLoaded>
    );
  }
}

const mapStateToProps = ({ applyOffers }) => ({ applyOffers });

export default connect(mapStateToProps, applyOffersActions)(ExportApplicants);
